import React, { useRef, useState } from 'react'
import classNames from 'classnames'
import Empty from '../../../image/empty.png'
import insEmpty from '../../../image/empty_ins.png'
import Pro2 from '../../../image/detail/pro2.png'
import versionNumber from '../../useFunModal/versionNumber'
import useVersionNumber from '../../../common/hooks/useVersionNumber'
import createInspiration from '../../useFunModal/createInspiration'
import { ossImg } from '../../../utils/image'
import Icon from '../../icon'
import LoadMore from '../../loadmore'
import './insList.less'

export default ({ data,
  onAddOrRemove,
  onCreatedInspiration,
  loading, onLoad, isEnd, isBatch, canCreateIdeaMass, currentIdeaMass, onChooseTaskOk, onChooseTaskClose }) => {
  const [unFoldIds, setUnFoldIds] = useState([])
  const [currentIdeaMassuUnFoldId, setCurrentIdeaMassuUnFoldId] = useState([])
  const $list = useRef()

  const { isRealTimeAuthLimit } = useVersionNumber()

  const onClickCollect = (e, item) => {
    e && e.stopPropagation()
    onAddOrRemove(item)
  }
  return <div className="mn-add-idea-masses-wrapper">
    <div className="idea-masses" ref={$list}>
      {data?.length ? <>
        {currentIdeaMass ? <div className="current-idea-mass">
          <div className="title">当前灵感集</div>
          <IdeaMassItem
            item={currentIdeaMass}
            unFoldIds={currentIdeaMassuUnFoldId}
            setUnFoldIds={setCurrentIdeaMassuUnFoldId}
            isBatch={isBatch}
            onClickCollect={onClickCollect}
          />
        </div> : null}
        { data?.map((item) => {
          const cover = item?.coverImgUrl || item?.lastBlogList?.[0]?.mainUrl
          return <IdeaMassItem
            key={item.id}
            item={item}
            cover={cover}
            unFoldIds={unFoldIds}
            setUnFoldIds={setUnFoldIds}
            isBatch={isBatch}
            onClickCollect={onClickCollect}
          />
        })}
        <LoadMore onLoad={onLoad} stop={isEnd} loading={loading} observerParams={{ root: $list.current }}>
          {loading ? <div style={{ height: 48, textAlign: 'center', paddingTop: 10 }}>加载中...</div> : null}
        </LoadMore>
      </> : <div className="ins-empty"><img src={insEmpty} />暂无相关灵感集</div> }
    </div>
    <div className="create-idea-mass">
      <div
        style={{ display: 'flex', alignItems: 'center', color: 'var(--m-text-1)', cursor: 'pointer' }}
        onClick={async (e) => {
          const isLimit = await isRealTimeAuthLimit('meinian_inspiration_limit')
          if (!isLimit) {
            versionNumber({
              title: '灵感集'
            })
            return
          }
          if (!canCreateIdeaMass) {
            e.stopPropagation()
            onCreatedInspiration(false)
          } else {
            createInspiration({
              onChooseTaskClose,
              onChooseTaskOk,
              onChange: (inspirationId, { name }) => {
                onCreatedInspiration?.(inspirationId, name)
              },
            })
          }
        }}
      ><div className="button"><Icon type="m-tianjia" /></div>创建灵感集</div>
    </div>
  </div>
}

const IdeaMassItem = ({ item, unFoldIds, setUnFoldIds, isBatch, onClickCollect }) => {
  const cover = item?.coverImgUrl || item?.lastBlogList?.[0]?.mainUrl
  return (
    <div className={classNames('idea-mass', { fold: !unFoldIds.includes(item.id) })}>
      <div
        className="idea-mass-item"
        style={{ cursor: item?.childInspirations?.length ? 'pointer' : 'default' }}
        onClick={() => (item?.childInspirations?.length
          ? setUnFoldIds(unFoldIds.includes(item.id) ? unFoldIds.filter(v => v !== item.id) : [...unFoldIds, item.id]) : {})}
      >
        <div
          className="item-cover"
          style={{ background: `url(${ossImg(cover, 40)}) center/cover no-repeat` }}
        >
          {!!item.cooperation && <div className="cooperation-icon">
            <Icon type="m-tuandui_xiao" style={{ fontSize: '14px' }} />
          </div>}
          {!cover && <div className="item-cover-empty-icon">
            <img style={{ width: '24px' }} src={Empty} alt="" />
          </div>}
        </div>
        <div className="item-title">
          <div className="item-title-top">
            <span className="inspiration-title" title={item.name}>{item.isPro === 1 && <img src={Pro2} className="coll-info-img" />}{item.name}</span>
            {item.childInspirations?.length ? <span className="spread-icon"><Icon type={unFoldIds.includes(item.id) ? 'm-Vxing_shang' : 'm-Vxing_xia'} /></span> : null}
          </div>
          <div className="item-username">{item.ownerName}</div>
        </div>
        <div style={{ flex: 1 }} />
        <a className={classNames('ins-list-collect-button', { cancel: item.currentFlag && !isBatch })} onClick={(e) => { onClickCollect(e, item) }}>{item.currentFlag && !isBatch ? '取消采集' : '采集'}</a>
      </div>
      {item?.childInspirations.length ? <SubIdeaMass
        data={item.childInspirations}
        onClickCollect={onClickCollect}
        isBatch={isBatch}
        ownerName={item.ownerName}
      /> : null}
    </div>
  )
}

const SubIdeaMass = (props) => {
  const { data, isBatch, ownerName } = props
  return <div className="add-sub-idea-masses">
    { data?.map((item) => {
      return <div key={item.name} className="idea-mass-item">
        <div className="item-title">
          {item.name}
          <div className="item-username">{ownerName || item.userName}</div>
        </div>
        <div style={{ flex: 1 }} />
        <a className={classNames('ins-list-collect-button', { cancel: item.currentFlag && !isBatch })} onClick={(e) => { props.onClickCollect(e, item) }}>{item.currentFlag && !isBatch ? '取消采集' : '采集'}</a>
      </div>
    })}
  </div>
}
